import * as constants from '../constants/ActionTypes';
import { chatType } from '../constants/UtilVariables';

const initialState = {
  isModalOpen: false,
  channel: '',
  fromChannel: '',
  topic: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case constants.LOAD_MODAL_CONTAINER :
      return Object.assign({}, state, { isModalOpen: true, channel: action.payload, topic: null });
    case constants.CLOSE_MODAL_CONTAINER :
      return Object.assign({}, state, { isModalOpen: false, channel: '' });
    case constants.LOGIN_CALLUS :
      return Object.assign({}, state, { isModalOpen: false, fromChannel: 'callUs', topic: null });
    case constants.LOGIN_CHAT_BOT :
      return Object.assign({}, state, { isModalOpen: false, fromChannel: chatType.chatBot, topic: action.payload });
    case constants.LOGIN_LIVE_CHAT :
      return Object.assign({}, state, { isModalOpen: false, fromChannel: chatType.liveChat, topic: action.payload });
    case constants.LOGIN_EMAIL :
      return Object.assign({}, state, { isModalOpen: false, fromChannel: 'emailUs', topic: null });
    case constants.LOGIN_EMAIL_NO_INTENT :
      return Object.assign({}, state, { isModalOpen: false, fromChannel: 'email', topic: null });
    case constants.REQUEST_CALLUS :
    case constants.REQUEST_BY_EMAIL :
      return Object.assign({}, state, { isModalOpen: false, fromChannel: '' });
    case constants.SELECT_TOPIC_L1:
    case constants.SELECT_TOPIC_L2:
    case constants.SELECT_TOPIC_L3:
    case constants.SELECT_TOPIC_RESET:
      return Object.assign({}, state, { isModalOpen: false, topic: null });
    default:
      return state;
  }
}
